import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ajax } from 'jquery';
import Calendar from 'react-calendar';
import './index.css';
import { Value } from 'react-calendar/dist/cjs/shared/types';

function getCurrentMonth(): string {
    const currentDate: Date = new Date();
    const year: number = currentDate.getFullYear();
    const month: number = currentDate.getMonth() + 1;
    const formattedMonth: string = month.toString().padStart(2, '0');
    return `${year}-${formattedMonth}`;
}

function getFormattedDate(currentDate: Date): string {
    const year: number = currentDate.getFullYear();
    const month: number = currentDate.getMonth() + 1;
    const day: number = currentDate.getDate();
    const formattedMonth: string = month.toString().padStart(2, '0');
    const formattedDay: string = day.toString().padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;
}
function replaceSpacesWithUnderscoresUsingReplaceAll(str: string): string {
    return str.replaceAll(' ', '_');
}
const Weeknotes = () => {
    const { hash } = useParams()
    const [value, onChange] = useState<Value>(new Date());
    const [monthData, setMonthData] = useState<any[]>([])

    useEffect(() => {
        try {
            const loadCalendarData = async () => {
                const result = await ajax({
                    method: "GET",
                    url: '/api/v1/countryball_card/note/list/' + getCurrentMonth(),
                })
                setMonthData(result)
            }
            loadCalendarData()
        } catch (err) {

        }
    }, [])

    const calendarContent = (calendarDate: any) => {
        const date = calendarDate.date;
        const dateString = getFormattedDate(date)
        const dateData = monthData.find(item => {
            return item.date === dateString
        })
        return <div className='day-content'>
            {
                dateData ?
                    <div className="note-avatar-box ball-wrap" onClick={() => { window.location.href = ('/note/edit/' + dateString) }}>
                        <img className='ball-pic' src={'https://oss.usecubes.cn/countryballs/new_balls/' + replaceSpacesWithUnderscoresUsingReplaceAll(dateData.country) + '.png'} alt={dateData.country} />
                        <img className='face-pic' src={'https://oss.usecubes.cn/countryballs/faces/' + (dateData.expressionType + 1 + dateData.expressionOrientation) + '.png'} />
                    </div>
                    :
                    <div className="note-avatar-box" onClick={() => { window.location.href = ('/note/edit/' + dateString) }}>
                    </div>
            }

        </div>
    }

    const changeMonth = async (data: any) => {
        const activeStartDate: Date = data.activeStartDate
        const year: number = activeStartDate.getFullYear();
        const month: number = activeStartDate.getMonth() + 1;
        const formattedMonth: string = month.toString().padStart(2, '0');
        const monthStr = `${year}-${formattedMonth}`;
        const result = await ajax({
            method: "GET",
            url: '/api/v1/countryball_card/note/list/' + monthStr,
        })
        setMonthData(result)
    }

    return (
        <div className='page-wrap card-page weeknotes-page'>
            {
                <div className="weeknotes-page-content">
                    <h3 className="weeknotes-title">我的国家球日记</h3>
                    <Calendar
                        onChange={onChange}
                        value={value}
                        tileContent={calendarContent}
                        onActiveStartDateChange={changeMonth}
                    />
                    <div className="add-new-note-box">
                        <a href="/note/edit" className="common-btn add-new-note">写日记</a>
                    </div>
                </div>
            }
        </div >
    );
}

export default Weeknotes